__turbopack_context__.v({
  "container": "LorryBookingSteps-module-scss-module__DuGlZW__container",
  "eyebrow": "LorryBookingSteps-module-scss-module__DuGlZW__eyebrow",
  "grid": "LorryBookingSteps-module-scss-module__DuGlZW__grid",
  "header": "LorryBookingSteps-module-scss-module__DuGlZW__header",
  "iconWrap": "LorryBookingSteps-module-scss-module__DuGlZW__iconWrap",
  "step": "LorryBookingSteps-module-scss-module__DuGlZW__step",
  "stepDescription": "LorryBookingSteps-module-scss-module__DuGlZW__stepDescription",
  "stepHead": "LorryBookingSteps-module-scss-module__DuGlZW__stepHead",
  "stepNumber": "LorryBookingSteps-module-scss-module__DuGlZW__stepNumber",
  "stepTitle": "LorryBookingSteps-module-scss-module__DuGlZW__stepTitle",
  "stepsSwiper": "LorryBookingSteps-module-scss-module__DuGlZW__stepsSwiper",
  "title": "LorryBookingSteps-module-scss-module__DuGlZW__title",
  "titleHighlight": "LorryBookingSteps-module-scss-module__DuGlZW__titleHighlight",
  "titleLine": "LorryBookingSteps-module-scss-module__DuGlZW__titleLine",
});
